(function ($) {
  'use strict';

  $(function () {

    /* ---------- FAQ accordion (single open at a time) ---------- */
    var $faqItems = $('.sk-faq-item');
    $faqItems.each(function () {
      var $item = $(this);
      var $toggle = $item.find('.js-faq-toggle');
      if (!$toggle.length) return;
      $toggle.on('click', function () {
        var willOpen = !$item.hasClass('open');
        $faqItems.removeClass('open').find('.js-faq-toggle').attr('aria-expanded', 'false');
        if (willOpen) {
          $item.addClass('open');
          $toggle.attr('aria-expanded', 'true');
        }
      });
    });

    /* ---------- Podcasts slider: 3 desktop, 2 tablet, 1 mobile ---------- */
    if (window.Swiper && $('#au-pod-swiper').length) {
      var $podControls = $('#au-pod-controls');
      var syncPodControls = function (sw) { $podControls.toggleClass('is-locked', !!sw.isLocked); };
      new window.Swiper('#au-pod-swiper', {
        slidesPerView: 1,
        spaceBetween: 20,
        breakpoints: {
          640: { slidesPerView: 2, spaceBetween: 20 },
          1024: { slidesPerView: 3, spaceBetween: 24 }
        },
        navigation: { nextEl: '#au-pod-next', prevEl: '#au-pod-prev' },
        pagination: { el: '#au-pod-dots', clickable: true },
        on: { init: syncPodControls, update: syncPodControls, resize: syncPodControls, lock: syncPodControls, unlock: syncPodControls }
      });
    }

    /* ---------- Physician meetings slider: 4 desktop, 2-3 tablet, 1 mobile ---------- */
    if (window.Swiper && $('#au-meet-swiper').length) {
      var $meetControls = $('.au-meet-controls');
      var syncMeetControls = function (sw) { $meetControls.toggleClass('is-locked', !!sw.isLocked); };
      new window.Swiper('#au-meet-swiper', {
        slidesPerView: 1.2,
        spaceBetween: 16,
        breakpoints: {
          540: { slidesPerView: 2, spaceBetween: 18 },
          900: { slidesPerView: 3, spaceBetween: 20 },
          1180: { slidesPerView: 4, spaceBetween: 20 }
        },
        navigation: { nextEl: '#au-meet-next', prevEl: '#au-meet-prev' },
        on: { init: syncMeetControls, update: syncMeetControls, resize: syncMeetControls, lock: syncMeetControls, unlock: syncMeetControls }
      });
    }

    /* ---------- Certifications modal ---------- */
    var $certModal = $('#pd-cert-modal');
    if ($certModal.length) {
      var $certTitle = $certModal.find('.js-cert-title');
      var $certSub = $certModal.find('.js-cert-sub');
      var $certImg = $certModal.find('.js-cert-img');
      $('.pd-cert-card, .js-view-cert').on('click', function () {
        var $card = $(this);
        $certTitle.text($card.data('name'));
        $certSub.text($card.data('sub'));
        $certImg.attr('src', $card.data('img')).attr('alt', $card.data('name'));
        $certModal.addClass('open');
      });
      $certModal.on('click', function (e) {
        if (e.target === this) $certModal.removeClass('open');
      });
      $certModal.find('.pd-cert-modal__close').on('click', function () {
        $certModal.removeClass('open');
      });
    }
  });
})(jQuery);
